import InteractiveDocs from './components/InteractiveDocs';
export { ichisSpdRegistry } from './content/registry';
export default InteractiveDocs;
